// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { yearsToDays as fn } from "../yearsToDays.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const yearsToDays = convertToFP(fn, 1);

// Fallback for modularized imports:
export default yearsToDays;
